import React, { useContext, useState, useEffect } from 'react'
import { FlexDiv } from '../../elements/NumberInput/NumberInputStyles'
import RollButton from '../RollButton/RollButton'
import BetInput from '../components/betInput/BetInput'
import Operations from '../components/operationButton/Operations'
import { MyContext } from '../../../context/createContext'

interface Bet_props {
  autoConfig: boolean
  startAuto: boolean
  handleRollUnder: () => void
  handleStake: (s: string, name: string) => void
  audio: any
  prec: number
}
export default function Bet({
  handleStake,
  handleRollUnder,
  autoConfig,
  startAuto,
  audio,
  prec,
}: Bet_props) {
  const { context } = useContext(MyContext)
  const { stake, rollUnder, handleNotification, auth, config } = context
  const { maxbet, minbet } = config
  const {
    balance: { currency },
  } = auth
  const [rollUnderValue, setRollUnder] = useState<string>(rollUnder)

  useEffect(() => {
    if (rollUnder == '1') {
      setRollUnder('1')
    } else if (rollUnder == '0') setRollUnder('0')
    else setRollUnder(rollUnder)
  }, [rollUnder])

  return (
    <FlexDiv marginBottom='15px' startAuto={startAuto}>
      <BetInput
        stake={stake}
        currency={currency}
        handleStake={handleStake}
        name='STAKE'
        maxBet={maxbet}
        minBet={minbet}
        title='BET AMOUNT'
        fontSize='24px'
        precise={prec}
        handleNotification={handleNotification}
      />
      <Operations
        stake={stake}
        tofix={prec}
        handleStake={handleStake}
        margin={autoConfig ? '9px' : ''}
        handleNotification={handleNotification}
        currency={currency}
        audio={audio}
      />
      <RollButton
        handleRollUnder={handleRollUnder}
        rollUnder={rollUnderValue == '1'}
        startAuto={startAuto}
      />
    </FlexDiv>
  )
}
